import React, { useCallback, useEffect, useState } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { PrintRounded } from "@material-ui/icons";

export default function PrinterClients(props) {
  const [printerClients, setPrinterClients] = useState([]);
  const [hubConnection, setHubConnection] = useState(null);

  async function onGetActivePrintClients(clients) {
    setPrinterClients(clients.map((client) => ({ ...client, isOnline: true })));
  }

  const onPrinterConnected = useCallback(
    (client) => {
      console.log(client);
      const index = printerClients.findIndex((c) => c.clientGuid === client.clientGuid || c.name === client.name);
      if (index !== -1) setPrinterClients((prev) => [...prev.slice(0, index), { ...client, isOnline: true }, ...prev.slice(index + 1)]);
      else setPrinterClients((prev) => [...prev, { ...client, isOnline: true }]);
    },
    [printerClients]
  );

  const onPrinterDisconnected = useCallback(
    (clientGuid) => {
      console.log(clientGuid);
      const index = printerClients.findIndex((c) => c.clientGuid === clientGuid);
      if (index !== -1) setPrinterClients((prev) => [...prev.slice(0, index), { ...prev[index], isOnline: false }, ...prev.slice(index + 1)]);
    },
    [printerClients]
  );

  useEffect(() => {
    if (!hubConnection) return;
    hubConnection.on("onPrinterConnected", onPrinterConnected);
    hubConnection.on("onPrinterDisconnected", onPrinterDisconnected);
    return () => {
      if (!hubConnection) return null;
      hubConnection.off("onPrinterConnected", onPrinterConnected);
      hubConnection.off("onPrinterDisconnected", onPrinterDisconnected);
    };
  }, [printerClients, hubConnection]);

  useEffect(() => {
    const eventId = props.match.params.id;
    let url = "https://jirango.com/onsitehub";
    if (window.location.host.includes("localhost")) url = "https://localhost:44331/onsitehub";
    const hubConnection = new HubConnectionBuilder().withUrl(url).build();

    (async () => {
      try {
        await hubConnection.start();

        hubConnection.on("onGetActivePrintClients", onGetActivePrintClients);
        hubConnection.on("onPrinterConnected", onPrinterConnected);
        hubConnection.on("onPrinterDisconnected", onPrinterDisconnected);

        hubConnection.invoke("getActivePrintClients", { monitor: true }, eventId);
        setHubConnection(hubConnection);
      } catch (error) {
        console.error(error);
      }
    })();

    return () => {
      hubConnection.stop();
    };
  }, []);

  return (
    <div style={{ width: "100%", height: "100vh", display: "grid", placeItems: "center" }}>
      <div style={{ display: "flex", flexWrap: "wrap", margin: "auto", maxWidth: 500 }}>
        {printerClients?.length > 0 ? (
          printerClients.map((client) => (
            <div key={client.clientGuid} style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", margin: 10 }}>
              <PrintRounded />
              <span style={{ display: "block", fontSize: 18 }}>{client.name}</span>
              <span style={{ background: client.isOnline ? "green" : "red", borderRadius: "100rem", padding: "2px 6px", color: "#fff" }}>{client.isOnline ? "Online" : "Offline"}</span>
            </div>
          ))
        ) : (
          <h1>Inga printers anslutna</h1>
        )}
      </div>
    </div>
  );
}
